import React from "react";

export interface CheckoutWebDynamicConfigContextValue {
    checkoutWebXP: {
        [key: string]: string;
    };
    checkoutWebWP: {
        [key: string]: string;
    };
}

export const CheckoutWebDynamicConfigContext = React.createContext<CheckoutWebDynamicConfigContextValue>({
    checkoutWebXP: {},
    checkoutWebWP: {},
});

if (__DEV__) {
    CheckoutWebDynamicConfigContext.displayName = "CheckoutWebDynamicConfigContext";
}
